var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome4Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e/icon/buildings/home_4_line",
    clipPath: "url(#clip0_13623_84689)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2 1.76667C7.67407 1.41111 8.32593 1.41111 8.8 1.76667L13.4667 5.26667C13.8024 5.51847 14 5.91366 14 6.33333V12.6667C14 13.4031 13.4031 14 12.6667 14H9.4C8.995 14 8.66667 13.6717 8.66667 13.2667V9.33333C8.66667 8.96513 8.3682 8.66667 8 8.66667C7.6318 8.66667 7.33333 8.96513 7.33333 9.33333V13.2667C7.33333 13.6717 7.005 14 6.6 14H3.33333C2.59695 14 2 13.4031 2 12.6667V6.33333C2 5.91366 2.19759 5.51847 2.53333 5.26667L7.2 1.76667ZM8 2.83333L3.33333 6.33333V12.6667H6V9.33333C6 8.22873 6.8954 7.33333 8 7.33333C9.1046 7.33333 10 8.22873 10 9.33333V12.6667H12.6667V6.33333L8 2.83333Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13623_84689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome4Line);
export default __webpack_public_path__ + "static/media/home_4_line.6f2385c0b40a84b0e5ea7c143011773e.svg";
export { ForwardRef as ReactComponent };